/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// Packages
import React, { useState, useEffect } from 'react'
import ApolloClient, { gql } from 'apollo-boost'
import Axios from 'axios'
import _lang from 'lodash/lang'
import _object from 'lodash/object'
import _util from 'lodash/util'
// import { useJsApiLoader, Autocomplete } from '@react-google-maps/api'
import { Modal, Button, Input, Form, Tag, message, Spin, Row, Col } from 'antd'
import { EditOutlined } from '@ant-design/icons'

const CreateEditBranch = (props) => {
	const [visible, setVisible] = useState(false)
	const {
		isEditMode,
		branch,
		branchName,
		index,
		branchArray,
		handleSelect,
		fromCreateEditCompany,
		companyUserCountry,
	} = props
	const [streetAddress, setStreetAddress] = useState(
		branch?.streetAddress || ''
	)
	const [isCoordinatesPresent, setIsCoordinatesPresent] = useState(false) //for create new branch

	const Client = new ApolloClient({
		uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
		headers: {
			'X-Hasura-Admin-Secret': process.env.REACT_APP_HASURA_SECRET,
		},
	})

	const onCreate = (values) => {
		const {
			branchArray,
			setBranchArray,
			branchCompany,
			setWorkingLocationReady,
			companyUserCountry,
		} = props
		const inputs = _object.pickBy(values, _util.identity)
		const newBranch = {
			name: inputs.branchName,
			mrt: companyUserCountry === 'SG' ? inputs.mrt : null,
			Address: {
				postalCode: inputs.postalCode,
				streetAddress:
          companyUserCountry === 'SG' ? inputs.streetAddress : streetAddress, // because different input for MY
				location: {
					type: 'Point',
					coordinates: [
						parseFloat(inputs.longitude),
						parseFloat(inputs.latitude),
					],
				},
				unit: inputs.unitNumber ? inputs.unitNumber : null,
			},
		}
		//branchCompany - prop from CreateJob, EditJob, SelectWorkingLocation
		if (branchCompany) {
			try {
				const { branchOptions, branches, selectedBranches } = branchArray
				Client.mutate({
					mutation: gql`
            mutation ($branchObj: [Branch_insert_input!]!) {
              insert_Branch(objects: $branchObj) {
                returning {
                  id
                }
              }
            }
          `,
					variables: {
						branchObj: {
							name: newBranch.name,
							company: branchCompany,
							mrt: newBranch.mrt,
							Address: {
								data: newBranch.Address,
							},
						},
					},
				})
					.then((newBranchRes) => {
						try {
							const {
								data: {
									insert_Branch: { returning },
								},
							} = newBranchRes
							if (returning && returning.length) {
								const { id } = returning[0]
								branchOptions.push({
									value: id,
									label: `${newBranch.name} - ${
										newBranch.Address.streetAddress
									}, ${
										newBranch.Address.unit !== null
											? newBranch.Address.unit + ','
											: ''
									} ${newBranch.Address.postalCode}`,
								})
								branches.push({
									id: id,
									name: newBranch.name,
									Address: newBranch.Address,
								})
								selectedBranches.push(id)

								handleSelect()
							}
						} catch (error) {
							console.error(error, 'newBranchRes-then-error')
						}
					})
					.catch((error) => {
						console.error(error, 'newBranchRes-error')
					})
					.finally(() => {
						setWorkingLocationReady(false)
						setTimeout(() => {
							setWorkingLocationReady(true)
						}, 100)
					})
			} catch (error) {
				console.error(error, 'error-branchCompany-handleOk')
			}
		} else {
			// For <EditCompany />, we set the state of branchArray and finally "update" the Company ...
			setBranchArray([...branchArray, newBranch])
			setStreetAddress('')
			setIsCoordinatesPresent(false)
		}
		setVisible(false)
	}

	const onEdit = (values) => {
		const { branchArray, setBranchArray, branchId } = props
		const inputs = _object.pickBy(values, _util.identity)
		const addressId = branchArray[index].Address.id

		const respectiveJobLocations = branchArray[index].JobLocations

		const updatedBranch = {
			id: branchId,
			name: inputs.branchName,
			mrt: inputs.mrt,
			Address: {
				id: addressId,
				postalCode: inputs.postalCode,
				streetAddress:
          companyUserCountry === 'SG' ? inputs.streetAddress : streetAddress, // because different input for MY
				location: {
					type: 'Point',
					coordinates: [
						parseFloat(inputs.longitude),
						parseFloat(inputs.latitude),
					],
				},
				unit: inputs.unitNumber ? inputs.unitNumber : null,
			},
			JobLocations: respectiveJobLocations,
			// Conditionally adding a property
			isAssociated: branchArray[index].isAssociated
				? branchArray[index].isAssociated
				: false,
		}
		// Copy of state arr ...
		const branchArrClone = _lang.cloneDeep(branchArray)
		branchArrClone[index] = updatedBranch

		setBranchArray(branchArrClone)

		setVisible(false)
	}

	return (
		<>
			{!isEditMode ? (
				<>
					<Button
						type="primary"
						onClick={() => setVisible(true)}
						block={!fromCreateEditCompany}
					>
            Create Working Location
					</Button>
					<CreateEditBranchForm
						visible={visible}
						onCreate={onCreate}
						onCancel={() => setVisible(false)}
						streetAddress={streetAddress}
						setStreetAddress={setStreetAddress}
						isEditMode={false}
						isCoordinatesPresent={isCoordinatesPresent}
						setIsCoordinatesPresent={setIsCoordinatesPresent}
						branchArray={branchArray}
						companyUserCountry={companyUserCountry}
					/>
				</>
			) : (
				<>
					<Button icon={<EditOutlined />} onClick={() => setVisible(true)}>
            Edit
					</Button>
					<CreateEditBranchForm
						visible={visible}
						onCreate={onEdit}
						onCancel={() => setVisible(false)}
						branch={branch}
						branchArray={branchArray}
						branchName={branchName}
						isEditMode={isEditMode}
						streetAddress={streetAddress}
						setStreetAddress={setStreetAddress}
						isCoordinatesPresent={isCoordinatesPresent}
						setIsCoordinatesPresent={setIsCoordinatesPresent}
						companyUserCountry={companyUserCountry}
					/>
				</>
			)}
		</>
	)
}

const CreateEditBranchForm = ({
	visible,
	onCreate,
	onCancel,
	isEditMode,
	branch,
	branchName,
	// streetAddress,
	// setStreetAddress,
	// isCoordinatesPresent,
	// setIsCoordinatesPresent,
	// companyUserCountry,
}) => {
	const [mrtStation, setMrtStation] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [addressBtnDisabled, setAddressBtnDisabled] = useState(true)
	const [form] = Form.useForm()
	// const [autoComplete, setAutoComplete] = useState({})

	// const [libraries] = useState(['places'])

	const clear = () => {
		form.resetFields()
		setMrtStation({
			id: null,
			name: null,
			lineColour: null,
			distance: null,
		})
		setIsLoading(false)
		setAddressBtnDisabled(true)
	}

	const handleAddressFromPostal = () => {
		setIsLoading(true)
		const queryPostal = form.getFieldValue('postalCode')
		if (queryPostal) {
			Axios.post(process.env.REACT_APP_ROUTE_ADDRESS_CHECK, {
				query: queryPostal,
			})
				.then((res) => {
					const { data } = res
					if (!_lang.isEmpty(data)) {
						const { trimAddress, longitude, latitude, mrtStation } = data
						form.setFieldsValue({
							streetAddress: trimAddress,
							longitude,
							latitude,
							mrt: mrtStation.id || null,
						})
						setMrtStation({
							id: mrtStation.id,
							name: mrtStation.name,
							lineColour: mrtStation.lineColour,
							distance: mrtStation.distance,
						})
						setIsLoading(false)
					} else {
						message.warning('Postal Code is not valid')
						clear()
					}
				})
				.catch((err) => {
					console.error(err, 'err handleAddressFromPostal')
				})
		} else {
			message.warning('Postal Code is not valid')
			clear()
		}
	}

	// Street address autocomplete, for malaysia only
	// eslint-disable-next-line no-unused-vars
	// const { isLoaded } = useJsApiLoader({
	// 	id: 'google-map-script',
	// 	googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
	// 	libraries,
	// })

	// const onLoad = (autocomplete) => {
	// 	setAutoComplete(autocomplete)
	// }

	// const onPlaceChanged = () => {
	// 	if (_lang.isEmpty(autoComplete)) {
	// 		console.log('auto complete is not ready')
	// 		return
	// 	}
	// 	const place = autoComplete.getPlace()

	// 	//google recommended check
	// 	if (place.geometry) {
	// 		const postalCodeObj = place.address_components.find(
	// 			(element) => element.types[0] === 'postal_code'
	// 		)
	// 		setStreetAddress(place.formatted_address)
	// 		form.setFieldsValue({
	// 			streetAddress: place.formatted_address,
	// 			longitude: place.geometry.location.lng(),
	// 			latitude: place.geometry.location.lat(),
	// 			postalCode: postalCodeObj ? postalCodeObj.long_name : '',
	// 		})
	// 		setIsCoordinatesPresent(true)
	// 	} else {
	// 		form.setFieldsValue({
	// 			streetAddress: place.name,
	// 			longitude: null,
	// 			latitude: null,
	// 		})
	// 		setIsCoordinatesPresent(false)
	// 	}
	// }
	useEffect(() => {
		// Existing record ...
		// setMrtStation here to fill up mrt column
		if (isEditMode) {
			const postalCode = branch.postalCode
			Axios.post(process.env.REACT_APP_ROUTE_ADDRESS_CHECK, {
				query: postalCode,
			})
				.then((res) => {
					const { data } = res
					if (!_lang.isEmpty(data)) {
						const { mrtStation, longitude, latitude } = data
						setMrtStation({
							id: mrtStation.id,
							name: mrtStation.name,
							lineColour: mrtStation.lineColour,
							distance: mrtStation.distance,
						})
						form.setFieldsValue({
							mrt: mrtStation.id || null,
							longitude,
							latitude,
						})
					}
				})
				.catch((err) => {
					console.error(err, 'err handleAddressFromPostal')
				})
		}
		// eslint-disable-next-line
  }, []);

	// const checkIsDisabled = () => {
	// 	if (!isEditMode) {
	// 		const disabled = isCoordinatesPresent ? false : true
	// 		return disabled
	// 	} else {
	// 		const disabled = branch.location.coordinates ? false : true
	// 		return disabled
	// 	}
	// }

	return (
		<Modal
			visible={visible}
			title={!isEditMode ? 'Add New Branch' : 'Edit Branch'}
			okText={!isEditMode ? 'Add Branch' : 'Confirm Changes'}
			onCancel={onCancel}
			onOk={() => {
				form.validateFields().then((values) => {
					// Upon clicking on Ok, pass values to the <Parent /> && resetFields
					form.resetFields()
					onCreate(values)
				})
			}}
		>
			<Form
				form={form}
				layout="vertical"
				initialValues={
					branch && branchName
						? {
							branchName: branchName,
							postalCode: branch.postalCode,
							streetAddress: branch.streetAddress,
							unitNumber: branch.unit,
							// ,
							// mrt: get
							// mrt: branch.mrt
							// searchAddr: branch.fullAddress
							// longitude:
						}
						: {}
				}
				// companyName: '',
				// streetAddress: '',
				// postalCode: '',
				// fullAddress: ''
			>
				{/* Branch Name */}
				{/* Company Name already registered during <Singup /> */}
				<Form.Item
					name="branchName"
					label={'Branch name'}
					rules={[
						{
							required: true,
							message: 'Please enter your company name',
						},
					]}
				>
					<Input placeholder={'eg. Findjobs @ JTC Launchpad'} />
				</Form.Item>

				{/* Postal Code */}
				<Row type="flex" justify="space-between" align="middle">
					<Col>
						<Form.Item
							name="postalCode"
							label={'Postal Code'}
							rules={[
								// {
								//   required: true,
								//   message: 'Please enter the postal code of your company'
								// },
								{
									pattern: /^\d{6}$/,
									min: 6,
									max: 6,
									length: 6,
									message: 'Postal Code is not valid',
								},
							]}
						>
							<Input
								type="number"
								placeholder="123456"
								onChange={() => {
									const postalCodeLength =
                        form.getFieldValue('postalCode').length
									if (postalCodeLength !== 6) setAddressBtnDisabled(true)
									else {
										setAddressBtnDisabled(false)
									}
								}}
							/>
						</Form.Item>
					</Col>
					<Col>
						<Button
							onClick={handleAddressFromPostal}
							loading={isLoading}
							disabled={addressBtnDisabled}
						>
                  Get Address
						</Button>
					</Col>
				</Row>
				{/* Street Address */}
				<Form.Item
					name="streetAddress"
					label={
						'Street Address (Kindly use Get Address to populate address)'
					}
					rules={[
						{
							required: true,
							message: 'Please enter the street address of the branch',
						},
					]}
				>
					<Input readOnly />
				</Form.Item>

				{/* Unit */}
				<Form.Item name="unitNumber" label={'Unit Number'}>
					<Input />
				</Form.Item>
				{/* MRT label */}
				<Form.Item label={'Nearest MRT Station'}>
					{mrtStation.id ? (
						<Tag color={mrtStation.lineColour}>
							<span style={{ fontWeight: 'bold' }}>{mrtStation.id}</span>
                  &nbsp;{mrtStation.name}
						</Tag>
					) : isLoading ? (
						<Spin />
					) : null}
				</Form.Item>
				{/* Nearest MRT Station */}
				<Form.Item name="longitude">
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="latitude">
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="mrt">
					<Input type="hidden" />
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default CreateEditBranch
